interface IProps {
  color?: string;
}
export const Support_Icon = ({ color = '#061F62' }: IProps) => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.20068 18.1992H7.00068C7.77388 18.1992 8.40068 18.826 8.40068 19.5992V22.3992C8.40068 23.1724 7.77388 23.7992 7.00068 23.7992H4.20068V13.9992C4.20068 8.58683 8.58829 4.19922 14.0007 4.19922C19.4131 4.19922 23.8007 8.58683 23.8007 13.9992V23.7992H21.0007C20.2275 23.7992 19.6007 23.1724 19.6007 22.3992V19.5992C19.6007 18.826 20.2275 18.1992 21.0007 18.1992H23.8007"
        stroke={color}
        stroke-width="2.1"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const Collection_Icon = ({ color = '#061F62' }: IProps) => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.30031 6.21875V4.11875C6.30031 3.34555 6.92711 2.71875 7.70031 2.71875H21.0003C21.7735 2.71875 22.4003 3.34555 22.4003 4.11875V9.71875M2.80141 22.4832L2.80151 11.8382C2.80152 10.772 2.80112 9.25329 2.80078 8.15365C2.80054 7.38024 3.42743 6.754 4.20084 6.754H10.8721L14.098 10.1999H23.8003C24.5735 10.1999 25.2003 10.8267 25.2003 11.6L25.1999 22.4834C25.1999 24.0298 23.9463 25.2833 22.3999 25.2833L5.6014 25.2833C4.05499 25.2833 2.80139 24.0297 2.80141 22.4832Z"
        stroke={color}
        stroke-width="2.1"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const Notification_Icon = ({ color = '#061F62' }: IProps) => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.5455 2.87605C15.0815 2.82895 14.6088 2.80469 14.1292 2.80469C7.87161 2.80469 2.79883 6.9342 2.79883 12.0282C2.79883 17.1222 7.87161 21.2517 14.1292 21.2517C15.1073 21.2517 16.0564 21.1509 16.9618 20.9612L21.2107 25.2047V19.2753C23.1181 17.9855 24.651 16.0473 25.1988 14.0047M25.1988 7.70469C25.1988 9.63768 23.6318 11.2047 21.6988 11.2047C19.7658 11.2047 18.1988 9.63768 18.1988 7.70469C18.1988 5.77169 19.7658 4.20469 21.6988 4.20469C23.6318 4.20469 25.1988 5.77169 25.1988 7.70469Z"
        stroke={color}
        stroke-width="2.1"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const Report_Icon = ({ color = '#061F62' }: IProps) => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.5003 2.80469V7.00469C17.5003 7.77789 18.1271 8.40469 18.9003 8.40469H23.1003M9.80034 8.40469H12.6003M9.80034 12.6047H18.2003M9.80034 16.8047H18.2003M21.0003 4.90469C20.3772 4.34719 19.7307 3.68596 19.3225 3.25651C19.0509 2.97074 18.6756 2.80469 18.2813 2.80469H7.70001C6.15362 2.80469 4.90002 4.05828 4.90001 5.60467L4.8999 22.4046C4.89989 23.951 6.15349 25.2046 7.69989 25.2046L20.2999 25.2047C21.8463 25.2047 23.0999 23.9511 23.1 22.4047L23.1003 7.56216C23.1003 7.20418 22.9638 6.86006 22.7153 6.60234C22.2559 6.12577 21.4887 5.34162 21.0003 4.90469Z"
        stroke={color}
        stroke-width="2.1"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const Operation_Icon = ({ color = '#061F62' }: IProps) => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.215 4.9634L11.5239 3.08247C11.851 2.61232 12.3876 2.33203 12.9603 2.33203H14.458C15.0287 2.33203 15.5635 2.61025 15.891 3.07752L17.1843 4.92241M10.215 4.9634C9.81037 5.54073 9.13774 5.82362 8.4238 5.77318M10.215 4.9634C9.8084 5.53934 9.13774 5.82596 8.4238 5.77318M8.4238 5.77318L6.09792 5.62716C5.53644 5.59191 4.99225 5.82875 4.63539 6.26367L3.69664 7.40778C3.31829 7.86889 3.20086 8.49097 3.38507 9.05828L4.05168 11.1112M4.05168 11.1112C4.15543 11.4476 4.1687 11.808 4.09446 12.1484M4.05168 11.1112C4.1569 11.447 4.16969 11.8067 4.09397 12.1519M4.09446 12.1484C4.01923 12.4847 3.85795 12.8023 3.6185 13.0594M4.09446 12.1484L4.09397 12.1519M3.6185 13.0594L2.09806 14.6947C1.69836 15.1246 1.54081 15.7262 1.67851 16.2968L2.00143 17.635C2.13868 18.2038 2.55106 18.6663 3.10039 18.8676L5.18945 19.6333C5.52184 19.7619 5.80899 19.971 6.02631 20.2344M3.6185 13.0594C3.85943 12.8044 4.01923 12.4878 4.09397 12.1519M6.02631 20.2344C6.24217 20.4985 6.38918 20.8173 6.44622 21.1624M6.02631 20.2344C6.24413 20.4985 6.39164 20.8164 6.44622 21.1624M6.02631 20.2344L6.02287 20.2306C6.00861 20.2133 5.99337 20.1953 5.97862 20.1785M6.44622 21.1624L6.80215 23.3488C6.89536 23.9214 7.26628 24.4106 7.79246 24.6549L9.14095 25.2809C9.65031 25.5174 10.2422 25.4951 10.7323 25.2209L12.705 24.1173M12.705 24.1173C13.0142 23.9436 13.3594 23.8565 13.7046 23.856M12.705 24.1173C12.8274 24.0476 12.9557 23.992 13.0875 23.9503C13.2876 23.8869 13.4961 23.8556 13.7046 23.856M13.7046 23.856C13.884 23.8564 14.0635 23.8801 14.2385 23.927C14.4013 23.9706 14.5596 24.0342 14.7096 24.1173M13.7046 23.856C14.0512 23.8556 14.3983 23.9427 14.7096 24.1173M14.7096 24.1173L16.7858 25.2413C17.2781 25.5077 17.8681 25.5227 18.3732 25.2814L19.7158 24.6401C20.2402 24.3897 20.606 23.8954 20.6922 23.3208L21.0096 21.2063M21.0096 21.2063C21.0642 20.8592 21.2093 20.5381 21.4246 20.2716M21.0096 21.2063C21.0622 20.8585 21.2083 20.5378 21.4246 20.2716M21.4246 20.2716C21.6385 20.0079 21.9222 19.7978 22.2526 19.6679M21.4246 20.2716C21.638 20.0069 21.9207 19.7962 22.2526 19.6679M22.2526 19.6679L24.3723 18.8372C24.9112 18.626 25.3109 18.1619 25.4398 17.5975L25.7526 16.2281C25.8812 15.6652 25.7238 15.0752 25.3321 14.6511L23.7965 12.9883M23.7965 12.9883C23.5527 12.7303 23.3825 12.422 23.2999 12.0944M23.7965 12.9883C23.682 12.8678 23.5836 12.736 23.5035 12.5963C23.412 12.4377 23.3437 12.2688 23.2999 12.0944M23.2999 12.0944C23.2188 11.7691 23.2237 11.4244 23.3265 11.0908L23.987 8.97351C24.1627 8.41036 24.0429 7.7966 23.6682 7.34092L22.7624 6.23918C22.4014 5.80012 21.8496 5.56373 21.2828 5.60526L18.9903 5.77318M18.9903 5.77318C18.6352 5.79825 18.2861 5.73062 17.9754 5.58515M18.9903 5.77318C18.6348 5.79969 18.2861 5.73152 17.9754 5.58515M17.9754 5.58515C17.6627 5.43781 17.3883 5.21125 17.1843 4.92241M17.9754 5.58515C17.6622 5.43835 17.3873 5.21239 17.1843 4.92241M4.09397 12.1519L4.09495 12.1467M17.6583 14.0111C17.6583 16.1869 15.8547 17.9506 13.6303 17.9506C11.4059 17.9506 9.60239 16.1869 9.60239 14.0111C9.60239 11.8353 11.4059 10.0715 13.6303 10.0715C15.8547 10.0715 17.6583 11.8353 17.6583 14.0111Z"
        stroke={color}
        stroke-width="2.1"
      />
    </svg>
  );
};
export const Analytics_Icon = ({ color = '#061F62' }: IProps) => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.19883 18.2047L8.69021 14.0047L11.8983 17.0047L18.9562 10.4048M14.1544 9.80469H19.5988V14.8958M5.59883 25.2047C4.05243 25.2047 2.79883 23.9511 2.79883 22.4047V5.60469C2.79883 4.05829 4.05243 2.80469 5.59883 2.80469H22.3988C23.9452 2.80469 25.1988 4.05829 25.1988 5.60469V22.4047C25.1988 23.9511 23.9452 25.2047 22.3988 25.2047H5.59883Z"
        stroke={color}
        stroke-width="2.1"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const BackOfficeHome_Icon = ({ color = 'EBEDEF' }: IProps) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.55572 1.51625C7.80134 1.27063 8.19957 1.27063 8.4452 1.51625L10.2393 3.31032C10.4849 3.55595 10.4849 3.95418 10.2393 4.19981L8.4452 5.99388C8.19957 6.2395 7.80134 6.2395 7.55572 5.99388L5.76164 4.1998C5.51602 3.95418 5.51602 3.55595 5.76164 3.31032L7.55572 1.51625Z"
        stroke={color}
        stroke-width="1.33339"
      />
      <path
        d="M11.7996 5.76018C12.0453 5.51455 12.4435 5.51455 12.6891 5.76018L14.4832 7.55425C14.7288 7.79987 14.7288 8.19811 14.4832 8.44373L12.6891 10.2378C12.4435 10.4834 12.0453 10.4834 11.7996 10.2378L10.0056 8.44373C9.75994 8.19811 9.75994 7.79987 10.0056 7.55425L11.7996 5.76018Z"
        stroke={color}
        stroke-width="1.33339"
      />
      <path
        d="M3.31179 5.76018C3.55741 5.51455 3.95565 5.51455 4.20127 5.76018L5.99535 7.55425C6.24097 7.79987 6.24097 8.19811 5.99534 8.44373L4.20127 10.2378C3.95565 10.4834 3.55741 10.4834 3.31179 10.2378L1.51771 8.44373C1.27209 8.19811 1.27209 7.79987 1.51771 7.55425L3.31179 5.76018Z"
        stroke={color}
        stroke-width="1.33339"
      />
      <path
        d="M7.55572 10.0041C7.80134 9.75848 8.19957 9.75848 8.4452 10.0041L10.2393 11.7982C10.4849 12.0438 10.4849 12.442 10.2393 12.6877L8.4452 14.4817C8.19957 14.7274 7.80134 14.7274 7.55572 14.4817L5.76164 12.6877C5.51602 12.442 5.51602 12.0438 5.76164 11.7982L7.55572 10.0041Z"
        stroke={color}
        stroke-width="1.33339"
      />
    </svg>
  );
};
